// extracted by mini-css-extract-plugin
export const layout = "layout-module--layout--Ws604";